import { IPointsMetadata, PointsTypes } from "@Models/IPoints";
import { IQuestionnairePoint } from "@Models/IQuestionnaireDetails";
import { ICertificateTableData } from "../types";

// TODO: TW-469 move into feature folder
export const mapPointMetaQueryToColumnData = (pointMetadata: IPointsMetadata[]): ICertificateTableData[] => {
    return pointMetadata.map((point) => {
        return {
            key: point.pointsMetadataId,
            id: point.pointsMetadataId,
            startDate: point.startDate,
            endDate: point.endDate,
            ...point,
        };
    });
};

export const mapQuestionnairePointToColumnData = (
    questionnairePoint: IQuestionnairePoint[]
): ICertificateTableData[] => {
    return questionnairePoint.map((point) => {
        return {
            key: point.pointId,
            id: point.pointId,
            creationDate: point.createdOn,
            startDate: point.startedOn,
            endDate: point.endedOn,
            points: point.pointsEarned,
            pointsType: PointsTypes.CME,
            ownerName: point.createdBy,
        };
    });
};
